export const SUCCESS_DEFAULT = 'SUCCESS_DEFAULT';
export const FAILURE_DEFAULT = 'FAILURE_DEFAULT';
export const LOAD_CHANGE_PASSWORD = 'LOAD_CHANGE_PASSWORD';
export const LOAD_CHANGE_PASSWORD_SUCCESS = 'LOAD_CHANGE_PASSWORD_SUCCESS';
export const LOAD_CHANGE_PASSWORD_FAILURE = 'LOAD_CHANGE_PASSWORD_FAILURE';
export const LOAD_CHANGE_PASSWORD_SETTING = 'LOAD_CHANGE_PASSWORD_SETTING';
export const LOAD_CHANGE_PASSWORD_SETTING_SUCCESS = 'LOAD_CHANGE_PASSWORD_SETTING_SUCCESS';
export const LOAD_CHANGE_PASSWORD_SETTING_FAILURE = 'LOAD_CHANGE_PASSWORD_SETTING_FAILURE';
export const BLANK_MSG = 'BLANK_MSG';
